module.exports = __webpack_public_path__ + "static/media/nb7.7fcdffa6.jpg";